/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'
import './header.scss'

import { Link } from 'react-router-dom'

import userIcon from '../../assets/svg/userIcon.svg'
import circle from '../../assets/svg/circle.svg'
import date from '../../assets/svg/dateIcon.svg'
import notificationIcon from '../../assets/svg/notificationIcon.svg'
import settingIcon from '../../assets/svg/settingIcon.svg'

import logo from '../../assets/svg/Logo.svg'

import { post, get, put } from '../../services/http'

import { useNavigate } from 'react-router-dom'

import Switch from "react-switch"

export default function index() {
  const navigate = useNavigate()
  
  const [name, setName] = useState('')
  const [position, setPosition] = useState('')
  const [dateHeader, setDateHeader] = useState('')
  const [shopStatus, setShopStatus] = useState()

  const token = localStorage.getItem('token')
  
  useEffect(() => {
    if (localStorage.getItem('data')) {
      const data = JSON.parse(localStorage.getItem('data'))
      setName(data.name)
      setPosition(data.position)
    }
    post('/api/auth/verify', {
      token: localStorage.getItem('token')
    }).then(response => {
      if(response.data.errors === 'توکن با این مشخصات یافت نشد') {
        navigate('/')
      }
    }).catch(error => {
      if(error.response.data.errors) {
        navigate('/')
      }
    })

    get('/api/auth/date').then(response => {
        response.data.shops.map(shop => {
          if (shop.status) {
            return setShopStatus(true)
          } 
          return  setShopStatus(false)
        })
        setDateHeader(`${response.data.day} ${response.data.month} ${response.data.year}`)
      })
  }, [name, navigate, position, shopStatus])

  const statusHandler = () => {
    put(`/api/admin/shops/status/update?token=${token}`, {
      status: !shopStatus
    }).then(response => {
      if(response.data.success) {
        setShopStatus(!shopStatus)
      }
    })
  }

  return (
    <header id='header'>
      <section className='right'>
        <div className='logo'>
          <Link to='https://cannolii.com' target='_blank'>
            <img src={logo} alt='logo' />
          </Link>
        </div>
        <div className='userProfileIcon'>
          <img src={userIcon} alt='user' />
          <img src={circle} alt='circle' />
        </div>
        <div className="userProfileText">
          <span>
            {name}
          </span>
          <span>
            {position}
          </span>
        </div>
        <div className='date'>
          <img src={date} alt="date" />
          {dateHeader}
        </div>
      </section>

      <section className='left'>
        <div className="message">
          رستوران <span className={shopStatus ? 'success' : 'danger'} >{shopStatus ? 'باز' : 'بسته'}</span> است
        </div>
        <div className="toggle">
          <Switch onChange={statusHandler} 
            checked={shopStatus ? shopStatus : false} 
            onColor="#86d3ff"
            onHandleColor="#2693e6"
            handleDiameter={30}
            uncheckedIcon={false}
            checkedIcon={false}
            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
            height={20}
            width={48}
            className="react-switch"
            id="material-switch"
            />
        </div>
        <div className="notification">
          <Link to=''>
            <img src={notificationIcon} alt='notificationIcon' />
          </Link>
        </div>
        <div className="setting">
          <Link to='/setting'>
            <img src={settingIcon} alt='settingIcon' />
          </Link>
        </div>
      </section>
    </header>
  )
}
